import { api } from './api';

export const articlesService = {
  getArticles: async () => {
    try {
      return await api.get('/api/articles');
    } catch (error) {
      console.error('Error fetching articles:', error);
      throw error;
    }
  }
};

export const fetchArticles = () => articlesService.getArticles();
